import { Navigate } from 'react-router-dom'

import { PATHS } from '@/shared/lib'

export function RootRedirect() {
  return <Navigate to={PATHS.map} replace />
}
